/**
 * Màn chờ của Biadi: viên bi số 8 lăn qua lăn lại trên mặt bàn.
 *
 * Ba kiểu dùng, khác nhau ở CHỖ ĐỨNG chứ không ở hiệu ứng:
 *   inline  - nằm trong dòng chảy của trang, cho một khối đang tải.
 *   center  - chiếm phần thân trang và đứng giữa, cho cả một trang đang tải.
 *   screen  - phủ kín màn hình kèm nền mờ, cho lượt tải chặn thao tác
 *             (loaderState + components/loader).
 *
 * Hiệu ứng thuần CSS, không ảnh, không thư viện: xem .cue-loader trong
 * app-ui.css.
 */
const BilliardLoader = ({
  label = "Đang tải…",
  variant = "inline",
}: {
  label?: string;
  variant?: "inline" | "center" | "screen";
}) => (
  <div className={`cue-loader cue-loader--${variant}`} role="status" aria-live="polite">
    <div className="cue-track">
      <span className="pool-ball" />
    </div>
    {label ? <div className="cue-label">{label}</div> : null}
  </div>
);

export default BilliardLoader;
